import {Spinner as ChakraSpinner} from '@mediwareinc/wellsky-dls-react';
import {createPortal} from 'react-dom';
import styles from './spinner.module.scss';

export const Spinner = ({
  children,
  overlay = false,
  block = false,
  ...props
}) => {
  const spinnerProps = {
    size: 'lg',
    thickness: '3px',
    ...props,
  };

  if (overlay) {
    return createPortal(
      <div className={styles.overlayType}>
        <ChakraSpinner {...spinnerProps} />
      </div>,
      document.body,
    );
  }

  if (block) {
    return (
      <div className={styles.blockType}>
        <ChakraSpinner {...spinnerProps} />
      </div>
    );
  }

  return <ChakraSpinner {...spinnerProps}>{children}</ChakraSpinner>;
};
